import { render, staticRenderFns } from "./edit-relevance-relation.vue?vue&type=template&id=7aa9c809"
import script from "./edit-relevance-relation.vue?vue&type=script&lang=ts"
export * from "./edit-relevance-relation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports